import apiRequest from "./apiRequest";

export const createOrder = async (params, token) => {
  const order = await apiRequest.post("v2/orders", params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return order.data;
};

export const getOrders = async (query, token) => {
  const order = await apiRequest.get(`v2/orders?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return order.data;
};

export const getOrderQuote = async (params, token) => {
  const quote = await apiRequest.post("v2/orders/quote", params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
  return quote.data;
};

export const getZoningOrders = async (query, token) => {
  const zoneOrders = await apiRequest.get(`v2/zoning/orders?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return zoneOrders.data;
};

export const getZoningOrderById = async (orderId, token) => {
  const zoneOrders = await apiRequest.get(`v2/zoning/order/${orderId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return zoneOrders.data;
};

export const downloadZonedFile = async (key, query, token) => {
  const file = await apiRequest.get(`v2/zoning/download/${key}?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return file.data;
};

export const getStackOrders = async (query, token) => {
  const stackOrders = await apiRequest.get(`v2/stack/orders?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return stackOrders.data;
};

export const getStackOrdersById = async (orderId, token) => {
  const stackOrders = await apiRequest.get(`v2/stack/orders/${orderId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return stackOrders.data;
};

export const downloadStackZonedFile = async (key, query, token) => {
  const file = await apiRequest.get(`v2/stack/download/${key}?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return file.data;
};
